function multicast(observers, observable) {
    let close;
    return () => {
        if (close) {
            close();
            close = undefined;
        }
        else {
            close = observable(value => {
                for (const observer of observers) {
                    observer(value);
                }
            });
        }
    };
}
export function subject(observable) {
    const observers = new Set();
    const toggle = multicast(observers, observable);
    return (observer) => {
        if (observers.has(observer))
            throw new Error('Observer already subscribed.');
        observers.add(observer);
        if (observers.size === 1) {
            toggle();
        }
        return () => {
            if (observers.delete(observer) && observers.size === 0)
                toggle();
        };
    };
}
export function changeObserver(observer, initialValue) {
    let prevValue = initialValue;
    return (value) => {
        if (!Object.is(value, prevValue)) {
            prevValue = value;
            observer(value);
        }
    };
}
//# sourceMappingURL=observing.js.map